var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lineup__info__wrapper" },
    [
      _vm.current_match && _vm.current_match.status === 1
        ? _c(
            "div",
            {
              class: [
                "indicator",
                {
                  active:
                    _vm.current_match.ls === 1 &&
                    _vm.current_match.lineups_generated === 2,
                },
              ],
            },
            [
              _c("p", { staticClass: "txt" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(this.getLineupStatusText(_vm.current_match)) +
                    "\n    "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "lineup-form-wrap" }, [
        _c("form", { staticClass: "lineup-form", attrs: { action: "" } }, [
          _c("div", { staticClass: "form-element mobile-config-sel" }, [
            _c(
              "div",
              { staticClass: "form-group platform-selection" },
              [
                _vm.lineup_selection.p_id
                  ? _c("select-list", {
                      attrs: {
                        id: "platform_selection_dd",
                        options: _vm.pf_dropdowns,
                        selected: _vm.lineup_selection.p_id,
                        label: "pname",
                        onSelect: _vm.onPlatformSelect,
                        identifier: "pid",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group strategy-selection" },
              [
                !isNaN(_vm.lineup_selection.s_id)
                  ? _c("select-list", {
                      attrs: {
                        id: "strategy_selection_dd",
                        options:
                          _vm.stg_dropdown[_vm.lineup_selection.p_id] || [],
                        selected: _vm.lineup_selection.s_id,
                        label: "name",
                        identifier: "sid",
                        onSelect: _vm.onStrategySelect,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("gamezy-ad", {
        attrs: { size: "mob_small", ad_id: "mob_small-ad-1", autoDetect: true },
      }),
      _vm._v(" "),
      _c("gamezy-ad", {
        attrs: { size: "web_small", ad_id: "web_small-ad-1", autoDetect: true },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "budget-wrap" }, [
        _c("span", [
          _vm._v("\n      " + _vm._s(_vm.translations.budget) + " -\n      "),
          _c("span", { staticClass: "budget" }, [
            _vm._v(_vm._s(_vm.lineup_details.ub)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "autocomplete" }, [
          _c(
            "button",
            {
              class: [
                "btn-autocomplete",
                _vm.locked_players.length || _vm.out_players.length
                  ? ""
                  : "btn-disabled",
              ],
              on: {
                click: function ($event) {
                  _vm.locked_players.length || _vm.out_players.length
                    ? _vm.autoCompleteLineup()
                    : function (e) {
                        return !1
                      }
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.translations.autocomplete) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "lineup-match-info" },
        [
          _c("ul", { staticClass: "tab-modes" }, [
            _c(
              "li",
              {
                class: [_vm.tab_view === "pitch" ? "active" : ""],
                on: {
                  click: function ($event) {
                    return _vm.toggleTab("pitch")
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.translations.viewTeamTab) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                class: [_vm.tab_view === "list" ? "active" : ""],
                on: {
                  click: function ($event) {
                    return _vm.toggleTab("list")
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.translations.editTeamTab) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.tab_view === "pitch"
            ? _c("pitch-view", {
                attrs: {
                  stg_list: _vm.stg_dropdown[_vm.lineup_selection.p_id] || [],
                  team: _vm.lineup_details.team,
                  team_id: _vm.selected_team.id,
                  selected_strategy: _vm.lineup_selection.s_id,
                  onChange: _vm.onStrategySelect,
                  platform: _vm.pf_dropdowns.find(function (pf) {
                    return pf.pid === _vm.lineup_selection.p_id
                  }),
                  has_players_selected:
                    _vm.out_players.length || _vm.locked_players.length,
                  current_match: _vm.current_match,
                  togglePlayerPopup: this.togglePlayerPopup,
                  printSkillName: _vm.printSkillName,
                  isFootball: _vm.current_sport === 2,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.tab_view === "list"
            ? _c(
                "div",
                { staticClass: "match-info-list" },
                [
                  _c("edit-team-view", {
                    attrs: {
                      current_match: _vm.current_match,
                      rating_tool_tip: _vm.rating_tool_tip,
                      xf_tool_tip: _vm.xf_tool_tip,
                      lock_tool_tip: _vm.lock_tool_tip,
                      closeToolTipExcept: _vm.closeToolTipExcept,
                      teamList: _vm.lineup_details.team,
                      printSkillName: _vm.printSkillName,
                      trending_tool_tip: _vm.trending_tool_tip,
                      addToTrending: _vm.addToTrending,
                      onOpenPlayerPopup: _vm.onOpenPlayerPopup,
                      ratingDisplayVal: _vm.ratingDisplayVal,
                      locked_players: _vm.locked_players,
                      out_players: _vm.out_players,
                      lockPlayer: _vm.lockPlayer,
                    },
                  }),
                  _vm._v(" "),
                  _c("gamezy-ad", {
                    attrs: {
                      size: "mob_small",
                      ad_id: "mob_small-ad-2",
                      autoDetect: true,
                    },
                  }),
                  _vm._v(" "),
                  _c("gamezy-ad", {
                    attrs: {
                      size: "web_small",
                      ad_id: "web_small-ad-2",
                      autoDetect: true,
                    },
                  }),
                  _vm._v(" "),
                  _vm.lineup_details.bench && _vm.lineup_details.bench.length
                    ? _c("edit-team-view", {
                        attrs: {
                          current_match: _vm.current_match,
                          heading: _vm.translations.bench_p_label,
                          clsName: "bench-players",
                          rating_tool_tip: _vm.rating_tool_tip,
                          xf_tool_tip: _vm.xf_tool_tip,
                          lock_tool_tip: _vm.lock_tool_tip,
                          closeToolTipExcept: _vm.closeToolTipExcept,
                          teamList: _vm.lineup_details.bench,
                          printSkillName: _vm.printSkillName,
                          trending_tool_tip: _vm.trending_tool_tip,
                          addToTrending: _vm.addToTrending,
                          onOpenPlayerPopup: _vm.onOpenPlayerPopup,
                          ratingDisplayVal: _vm.ratingDisplayVal,
                          locked_players: _vm.locked_players,
                          out_players: _vm.out_players,
                          lockPlayer: _vm.lockPlayer,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.lineup_details.excluded &&
                  _vm.lineup_details.excluded.length
                    ? _c("edit-team-view", {
                        attrs: {
                          current_match: _vm.current_match,
                          heading: _vm.translations.out_p_label,
                          clsName: "excluded-players",
                          rating_tool_tip: _vm.rating_tool_tip,
                          xf_tool_tip: _vm.xf_tool_tip,
                          lock_tool_tip: _vm.lock_tool_tip,
                          closeToolTipExcept: _vm.closeToolTipExcept,
                          teamList: _vm.lineup_details.excluded,
                          printSkillName: _vm.printSkillName,
                          trending_tool_tip: _vm.trending_tool_tip,
                          addToTrending: _vm.addToTrending,
                          onOpenPlayerPopup: _vm.onOpenPlayerPopup,
                          ratingDisplayVal: _vm.ratingDisplayVal,
                          locked_players: _vm.locked_players,
                          out_players: _vm.out_players,
                          lockPlayer: _vm.lockPlayer,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.current_match.status == 1
        ? _c("recommended-contests", {
            attrs: { current_match: _vm.current_match },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.top_fantasy_xi_error.status
        ? _c(
            "div",
            { staticClass: "toast-wrap", on: { click: _vm.closeToast } },
            [
              _c("div", { staticClass: "toast-container" }, [
                _c("div", { staticClass: "toast-content" }, [
                  _c("div", { staticClass: "toast-msg" }, [
                    _c("p", { staticClass: "toast-text" }, [
                      _vm._v(_vm._s(_vm.top_fantasy_xi_error.msg)),
                    ]),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.show_loader
        ? _c("loader", { attrs: { text: "Loading lineup" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "user-note" }, [
      _c("strong", [_vm._v("Disclaimer : ")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Please don’t copy the team, this team is based on analysis, understanding and past performance. Make your own decision, considering player score, rating and form mentioned."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }